// extracted by mini-css-extract-plugin
export default {"playbutton":"PlayButton_playbutton__2fwVb","ripple":"PlayButton_ripple__T2HhY"};